import React, { FC, useState } from 'react'
import { FlexContainer } from '@reapit/elements'
import { SectionTile } from '@reapitform/dashboard-ui'
import PersonalInformationDisplayView from './personal-information-display-view'
import PersonalInformationEditForm from './personal-information-edit-form'
import { useUserProfile } from '../../../../api/user-profile'
import PersonalInformationDisplayViewLoading from './personal-information-display-view/loader'

const PersonalInformationSection: FC = () => {
  const [isEdited, setIsEdited] = useState(false)
  const { data, loading } = useUserProfile()

  const handleActionClick = () => {
    if (loading) return

    setIsEdited(true)
  }

  const handleActionClose = () => setIsEdited(false)

  return (
    <SectionTile
      title="Personal Information"
      actionTitle={isEdited ? '' : 'Edit'}
      onActionClick={handleActionClick}
      disableMarginBottom
    >
      <FlexContainer isFlexColumn>
        {loading ? (
          <PersonalInformationDisplayViewLoading />
        ) : isEdited ? (
          <PersonalInformationEditForm onClose={handleActionClose} onSuccess={handleActionClose} defaultData={data} />
        ) : (
          <PersonalInformationDisplayView {...data} />
        )}
      </FlexContainer>
    </SectionTile>
  )
}

export default PersonalInformationSection
